module.exports = __webpack_public_path__ + "media/images/malvinas/Sist_Malvinas_Blanco-3355b61c0df98ed973cb2f400c57bd7f.svg";